import { api } from "api/api";
import Cfop from "model/fiscal/Cfop";

export default class CfopService {
    listar(tipoOperacao?: string | null, destinoOperacao?: string | null): Promise<Cfop[]> {
        return api.get<Cfop[]>("/cfop/getAll", { params: {
            tipoOperacao: tipoOperacao || undefined,
            destinoOperacao: destinoOperacao || undefined
        } }).then(response => response.data);
    }

    compativel(codigo: string | null | undefined, tipoOperacao: string, destinoOperacao?: string | null): boolean {
        if (!codigo || !/^[123567]\d{3}$/.test(codigo)) return false;
        const prefixos = tipoOperacao === "ENTRADA" ? ["1", "2", "3"] : ["5", "6", "7"];
        const indice = ["INTERNA", "INTERESTADUAL", "EXTERIOR"].indexOf(destinoOperacao ?? "");
        return indice >= 0 ? codigo.startsWith(prefixos[indice]) : prefixos.includes(codigo[0]);
    }
}
